"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { usePathname } from "next/navigation";
import Image from "next/image";
import { ThemeToggle } from "~/components/theme-toggle";
import LanguageSwitcher from "~/app/_components/language-switcher";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "~/components/ui/button";
import { useTranslations, useLocale } from "next-intl";
import { authClient } from "~/lib/auth-client";
import { isPricingEnabledClient } from "~/lib/pricing";
import { BrandLogo } from "~/components/ui/brand-logo";
export function Header(t0) {
  const $ = _c(41);
  const {
    locale: propLocale,
    hasPosts: t1,
    enablePricing: t2
  } = t0;
  const hasPosts = t1 === undefined ? true : t1;
  t2 === undefined ? false : t2;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const pathname = usePathname();
  const t = useTranslations("layout.header");
  useLocale() || propLocale;
  const {
    data: session
  } = authClient.useSession();
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = isPricingEnabledClient();
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const pricingEnabled = t3;
  const isLoggedIn = !!session?.user;
  const isAdmin = session?.user?.role === "admin";
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Link href="/" className="flex items-center gap-2"><BrandLogo /></Link>;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t) {
    t5 = t("features");
    $[2] = t;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== pathname || $[5] !== t5) {
    t6 = <NavLink href="/features" currentPath={pathname}>{t5}</NavLink>;
    $[4] = pathname;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== pathname || $[8] !== t) {
    t7 = pricingEnabled && <NavLink href="/pricing" currentPath={pathname}>{t("pricing")}</NavLink>;
    $[7] = pathname;
    $[8] = t;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== hasPosts || $[11] !== pathname || $[12] !== t) {
    t8 = hasPosts && <NavLink href="/blog" currentPath={pathname}>{t("blog")}</NavLink>;
    $[10] = hasPosts;
    $[11] = pathname;
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6 || $[15] !== t7 || $[16] !== t8) {
    t9 = <nav className="hidden items-center gap-6 text-sm font-medium md:flex">{t6}{t7}{t8}</nav>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== isAdmin || $[19] !== isLoggedIn || $[20] !== t) {
    t10 = <div className="mr-2 hidden items-center gap-2 md:flex">{!pricingEnabled ? <>{isLoggedIn ? <Link href="/app" className="rounded-full px-4 py-2 text-sm font-medium text-slate-700 transition-all hover:text-slate-900 dark:text-white dark:hover:text-gray-100">{t("accessApp")}</Link> : <Link href="/auth/signin" className="rounded-full px-4 py-2 text-sm font-medium text-slate-700 transition-all hover:text-slate-900 dark:text-white dark:hover:text-gray-100">{t("signIn")}</Link>}<Link href="/waitlist"><Button size="sm" className="rounded-full border-0 bg-gradient-to-r from-blue-600 to-teal-400 text-white hover:opacity-90 hover:shadow-lg">{t("waitlist")}</Button></Link></> : isLoggedIn ? <>{isAdmin && <Link href="/admin" className="hidden rounded-full px-4 py-2 text-sm font-medium text-slate-700 transition-all hover:bg-slate-100 lg:block dark:text-gray-200 dark:hover:bg-slate-800">{t("administration")}</Link>}<Link href="/app"><Button size="sm" className="rounded-full border-0 bg-gradient-to-r from-blue-600 to-teal-400 text-white hover:opacity-90 hover:shadow-lg">{t("accessApp")}</Button></Link></> : <><Link href="/auth/signin" className="rounded-full px-4 py-2 text-sm font-medium text-slate-700 transition-all hover:text-slate-900 dark:text-white dark:hover:text-gray-100">{t("signIn")}</Link><Link href="/auth/signup"><Button size="sm" className="rounded-full border-0 bg-gradient-to-r from-blue-600 to-teal-400 text-white hover:opacity-90 hover:shadow-lg">{t("signUp")}</Button></Link></>}</div>;
    $[18] = isAdmin;
    $[19] = isLoggedIn;
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ThemeToggle />;
    t12 = <LanguageSwitcher />;
    $[22] = t11;
    $[23] = t12;
  } else {
    t11 = $[22];
    t12 = $[23];
  }
  let t13;
  if ($[24] !== isMenuOpen) {
    t13 = <button className="rounded-md p-2 text-gray-600 hover:bg-gray-100 md:hidden dark:text-gray-300 dark:hover:bg-gray-800" onClick={() => setIsMenuOpen(!isMenuOpen)}>{isMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}</button>;
    $[24] = isMenuOpen;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t10 || $[27] !== t13) {
    t14 = <div className="flex items-center gap-2">{t10}{t11}{t12}{t13}</div>;
    $[26] = t10;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t14 || $[30] !== t9) {
    t15 = <div className="container mx-auto flex h-full items-center justify-between px-4">{t4}<div className="flex items-center gap-8">{t9}{t14}</div></div>;
    $[29] = t14;
    $[30] = t9;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== hasPosts || $[33] !== isAdmin || $[34] !== isLoggedIn || $[35] !== isMenuOpen || $[36] !== t) {
    t16 = isMenuOpen && <div className="absolute top-16 right-0 left-0 border-b border-gray-200 bg-white shadow-lg md:hidden dark:border-gray-800 dark:bg-gray-950"><nav className="container mx-auto flex flex-col gap-2 px-4 py-6"><Link href="/features" className="rounded-xl px-4 py-3 text-base font-medium text-gray-700 transition-all hover:bg-gray-50 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-white" onClick={() => setIsMenuOpen(false)}>{t("features")}</Link>{pricingEnabled && <Link href="/pricing" className="rounded-xl px-4 py-3 text-base font-medium text-gray-700 transition-all hover:bg-gray-50 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-white" onClick={() => setIsMenuOpen(false)}>{t("pricing")}</Link>}{hasPosts && <Link href="/blog" className="rounded-xl px-4 py-3 text-base font-medium text-gray-700 transition-all hover:bg-gray-50 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-white" onClick={() => setIsMenuOpen(false)}>{t("blog")}</Link>}<div className="my-2 h-px bg-gray-100 dark:bg-gray-800" />{!pricingEnabled ? <>{isLoggedIn ? <Link href="/app" className="w-full rounded-md py-3 text-center text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 dark:text-gray-200 dark:hover:bg-gray-900" onClick={() => setIsMenuOpen(false)}>{t("accessApp")}</Link> : <Link href="/auth/signin" className="w-full rounded-md py-3 text-center text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 dark:text-gray-200 dark:hover:bg-gray-900" onClick={() => setIsMenuOpen(false)}>{t("signIn")}</Link>}<Link href="/waitlist" className="w-full" onClick={() => setIsMenuOpen(false)}><Button className="w-full rounded-full border-0 bg-gradient-to-r from-blue-600 to-teal-400 text-white hover:opacity-90 hover:shadow-lg">{t("waitlist")}</Button></Link></> : isLoggedIn ? <>{isAdmin && <Link href="/admin" className="w-full rounded-md py-3 text-center text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 dark:text-gray-200 dark:hover:bg-gray-900" onClick={() => setIsMenuOpen(false)}>{t("administration")}</Link>}<Link href="/app" className="w-full" onClick={() => setIsMenuOpen(false)}><Button className="w-full bg-teal-600 text-white hover:bg-teal-700">{t("accessApp")}</Button></Link></> : <><Link href="/auth/signin" className="w-full rounded-md py-3 text-center text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 dark:text-gray-200 dark:hover:bg-gray-900" onClick={() => setIsMenuOpen(false)}>{t("signIn")}</Link><Link href="/auth/signup" className="w-full" onClick={() => setIsMenuOpen(false)}><Button className="w-full rounded-full border-0 bg-gradient-to-r from-blue-600 to-teal-400 text-white hover:opacity-90 hover:shadow-lg">{t("signUp")}</Button></Link></>}</nav></div>;
    $[32] = hasPosts;
    $[33] = isAdmin;
    $[34] = isLoggedIn;
    $[35] = isMenuOpen;
    $[36] = t;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t15 || $[39] !== t16) {
    t17 = <header className="fixed inset-x-0 top-0 z-50 h-16 border-b border-gray-200/50 bg-white/80 backdrop-blur-xl dark:border-gray-800/50 dark:bg-gray-950/80">{t15}{t16}</header>;
    $[38] = t15;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  return t17;
}
function NavLink(t0) {
  const $ = _c(4);
  const {
    href,
    currentPath,
    children
  } = t0;
  const isActive = currentPath.includes(href);
  const t1 = `text-sm font-medium transition-colors ${isActive ? "font-bold text-blue-600 dark:text-blue-400" : "text-slate-600 hover:text-blue-600 dark:text-slate-300 dark:hover:text-blue-400"}`;
  let t2;
  if ($[0] !== children || $[1] !== href || $[2] !== t1) {
    t2 = <Link href={href} className={t1}>{children}</Link>;
    $[0] = children;
    $[1] = href;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}